var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 15.625C11.3983 15.625 13.6719 13.3514 13.6719 10.5469C13.6719 7.7423 11.3983 5.46875 8.59375 5.46875C5.78918 5.46875 3.51562 7.7423 3.51562 10.5469C3.51562 13.3514 5.78918 15.625 8.59375 15.625Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1777 5.65785C15.8762 5.46106 16.6087 5.41623 17.326 5.52638C18.0432 5.63653 18.7285 5.8991 19.3357 6.29641C19.9429 6.69372 20.458 7.21653 20.8461 7.82965C21.2343 8.44276 21.4865 9.13194 21.5859 9.85075C21.6853 10.5696 21.6294 11.3013 21.4222 11.9968C21.2149 12.6922 20.8611 13.3351 20.3844 13.8823C19.9078 14.4294 19.3194 14.8681 18.6589 15.1687C17.9985 15.4693 17.2813 15.6249 16.5556 15.6249",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 19.277C2.3556 18.1489 3.40849 17.2282 4.63228 16.5925C5.85606 15.9569 7.21482 15.6251 8.59383 15.625C9.97284 15.6249 11.3316 15.9567 12.5555 16.5922C13.7793 17.2278 14.8323 18.1484 15.6254 19.2765",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5547 15.625C17.9338 15.624 19.2929 15.9553 20.5168 16.591C21.7408 17.2266 22.7935 18.1477 23.586 19.2765",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ab36585aa3efaa63d91ca47df03c4664.svg";
export { ForwardRef as ReactComponent };